import React from 'react';
import './Spacer.css'

const Spacer = () => {
    return (
        <div className="spacer-container">

        </div>
    )
}

export default Spacer;